// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-name-step h2[data-v-491c5bd1],.flow-name-step p[data-v-491c5bd1]{text-align:center}.flow-name-step h2[data-v-491c5bd1]{font-size:18px;font-weight:700;color:#141c20;margin-bottom:5px}.flow-name-step p[data-v-491c5bd1]{font-size:14px;font-weight:400;color:#7c8b91;margin-bottom:33px}.flow-name-step input[data-v-491c5bd1]{height:54px;padding:20px 15px 18px;border-radius:10px!important}.flow-name-step .error[data-v-491c5bd1]{font-size:14px;color:#ff5b61;margin:7px 0}", ""]);
// Exports
module.exports = exports;
